import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getSection } from 'actions/sections';
import StudentGuardianSelector from 'containers/Forms/Partials/StudentGuardianSelector';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Expandable, List } from 'UI';
import { Button } from '@haldor/ui';

var AddMeetingInstance = /*#__PURE__*/function (_Component) {
  _inherits(AddMeetingInstance, _Component);

  var _super = _createSuper(AddMeetingInstance);

  function AddMeetingInstance(props) {
    var _this;

    _classCallCheck(this, AddMeetingInstance);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var currentSelected = [];

      _this.props.instances.forEach(function (instance) {
        currentSelected.push(instance.studentId);
      });

      _this.setState({
        currentSelected: currentSelected
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        values.instances = [];

        _this.state.selectedUsers.forEach(function (student) {
          var instance = {
            date: null,
            endDate: null,
            description: null,
            participants: [],
            status: 'ACTIVE'
          };

          if (student.selected) {
            var participant = {
              userID: student.studentId,
              userType: "STUDENT",
              sectionId: student.sectionId
            };
            instance.participants.push(participant);
          }

          if (student.guardians != null) {
            student.guardians.forEach(function (guardian) {
              var participant = {
                userID: guardian.id,
                userType: "GUARDIAN",
                sectionId: student.sectionId
              };
              instance.participants.push(participant);
            });
          }

          var currentUser = {
            userID: _this.props.currentUser.id,
            userType: 'USER',
            sectionId: student.sectionId
          };
          instance.participants.push(currentUser);
          values.type = "EVALUATION";
          instance.studentId = student.studentId;
          values.instances.push(instance);
        });

        if (_this.props.onSubmit) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdate", function (selectedUsers) {
      _this.setState({
        selectedUsers: selectedUsers
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: '1rem',
          color: 'red'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: '1rem',
          color: 'red'
        }
      }, warning)));
    });

    _this.state = {
      sectionId: 0,
      date: null,
      endDate: null,
      description: null,
      error: null,
      selectedUsers: [],
      currentSelected: []
    };
    return _this;
  }

  _createClass(AddMeetingInstance, [{
    key: "findSection",
    value: function findSection() {
      var sectionId = 0;
      this.props.instances.forEach(function (instance) {
        instance.participants.forEach(function (participant) {
          if (participant.sectionID != null) {
            sectionId = participant.sectionID;
          }
        });
      });
      return sectionId;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting;
      var sectionId = this.findSection();
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement(Expandable, {
        contentStyles: {
          padding: '1em 0rem'
        },
        contentStylesClosed: {
          padding: '0'
        },
        headerStyles: this.state.error != null ? {
          border: '1px solid red'
        } : {},
        whiteBackground: true,
        open: true,
        title: this.props.translate('participants')
      }, /*#__PURE__*/React.createElement(StudentGuardianSelector, {
        mentorGroups: true,
        onUpdate: this.onUpdate,
        sectionId: sectionId,
        currentSelected: this.state.currentSelected
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, null, this.props.translate('save')))));
    }
  }]);

  return AddMeetingInstance;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  getSection: getSection
})(reduxForm({
  form: 'AddMeetingInstance',
  destroyOnUnmount: true
})(AddMeetingInstance));